import { useContext } from "solid-js";
import Offcanvas from "./Offcanvas";
import NavbarContext from "./NavbarContext";
const NavbarOffcanvas = (props) => {
    const context = useContext(NavbarContext);
    return (<Offcanvas show={!!context?.expanded} {...props}/>);
};
export default NavbarOffcanvas;
